import { getAnalytics, logEvent, type Analytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAq9temyFMNj-gWKE1PcSlDACrFjJ7XBZg",
  authDomain: "desi-dott.firebaseapp.com",
  projectId: "desi-dott",
  storageBucket: "desi-dott.firebasestorage.app",
  messagingSenderId: "1045701236362",
  appId: "1:1045701236362:web:7e29ab915fb03f95813f73",
  measurementId: "G-TQ5PZ9RV1B",
};

const app = initializeApp(firebaseConfig);
let analytics: Analytics | null = null;

if (typeof window !== "undefined") {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    analytics = null;
  }
}

const trackEvent = (
  eventName: string,
  eventParams: Record<string, string | number | boolean> = {}
) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

export { analytics, trackEvent };
